<template>
  <div class="container">
    <div class="left-part">
      <div class="equipment-title">抄表器设备</div>
    </div>
    <div class="right-part">
      <div class="right-top">
        <el-form :model="form">
          <div style="display: flex; justify-content: space-between">
            <el-form-item label="全局搜索：">
              <el-input
                v-model="form.searchContent"
                placeholder="请输入企业名称或电站名称"
                style="width: 15.6vw"
              ></el-input>
            </el-form-item>
            <el-form-item label="MAC码：" style="margin-left: 5vh;">
              <el-input
                v-model="form.mrMac"
                placeholder="请输入MAC码"
                style="width: 15.6vw"
              ></el-input>
            </el-form-item>
            <el-form-item label="表号：" style="margin-left: 5vh;">
              <el-input
                v-model="form.mrMeCard"
                placeholder="请输入表号"
                style="width: 15.6vw"
              ></el-input>
            </el-form-item>
          </div>
          <div
            style="width: 100%; display: flex; justify-content: space-between"
          >
            <el-form-item label="设备类型：">
              <el-select
                v-model="form.equipmentType"
                placeholder="请选择类型"
                style="width: 15.6vw"
              >
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.typeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <div style="display: flex">
              <div class="add-btn" @click="addNew">添加</div>
              <div class="add-btn" @click="query">查询</div>
              <div class="add-btn" @click="reset">重置</div>
            </div>
          </div>
        </el-form>
      </div>
      <el-table
        :data="readerList"
        :header-cell-style="headerStyle"
        :cell-style="rowStyle"
      >
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column
          prop="gfEnterprise.etName"
          label="企业名称"
        ></el-table-column>
        <el-table-column
          prop="gfPowerStation.psName"
          label="电站名称"
        ></el-table-column>
        <el-table-column prop="mrMeName" label="电表名称"></el-table-column>
        <el-table-column prop="mrMeCard" label="表号"></el-table-column>
        <el-table-column label="电表类型">
          <template slot-scope="scope">
            <span v-if="scope.row.mrWhType == '1'"> 总电表 </span>
            <span v-if="scope.row.mrWhType == '2'"> 光伏电表 </span>
          </template></el-table-column
        >
        <el-table-column prop="mrMac" label="节点MAC码"></el-table-column>
        <el-table-column label="节点状态">
          <template slot-scope="scope">
            <span
              v-if="scope.row.gfNode != null && scope.row.gfNode.ndSmSta == 0"
              >正常</span
            >
            <span
              v-if="scope.row.gfNode != null && scope.row.gfNode.ndSmSta == 1"
              >异常</span
            >
          </template>
        </el-table-column>
        <el-table-column label="电表状态">
          <template slot-scope="scope">
            <span v-if="scope.row.sta == 0">在线</span>
            <span v-if="scope.row.sta == 1">离线</span>
          </template>
        </el-table-column>
        <el-table-column prop="mrMeCard" label="表号"></el-table-column>
        <el-table-column prop="mrUf" label="上传频率"></el-table-column>
        <el-table-column prop="mrMagnification" label="倍率"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="100"
        layout="sizes, prev, pager, next , total"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getReaderEquipment,
  getEquipmentType,
  deleteReaderEquipment,
} from "@/api/equipment";
export default {
  name: "readerEquipment",
  data() {
    return {
      form: {
        searchContent: "", // 搜索内容
        equipmentType: "", // 设备类型
        mrMac:'', // MAC码
        mrMeCard:'',
      },
      typeList: [], // 设备类型
      readerList: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      type: "",
    };
  },
  methods: {
    headerStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center;font-size:calc(100vw * 15 / 1920);";
    },
    rowStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center;font-size:calc(100vw * 14 / 1920);";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    // 获取查询列表
    getList() {
      let data = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        title: this.form.searchContent,
        mrType: this.form.equipmentType,
        mrMeCard:this.form.mrMeCard,
        mrMac:this.form.mrMac
      };
      getReaderEquipment(data).then((res) => {
        console.log(res, "大家看吧");
        this.readerList = res.rows;
        this.total = res.total;
      });
    },
    // 获取设备类型
    getTypeList() {
      getEquipmentType().then((res) => {
        console.log(res, "滴哦萨基哦");
        this.typeList = res.data;
      });
    },
    // 查询
    query() {
      this.currentPage = 1
      this.getList();
    },
    // 新增
    addNew() {
      this.$router.push("/addMeterReading");
    },
    // 修改
    handleEdit(row) {
      this.$router.push({
        path: "/addMeterReading",
        query: {
          id: row.id,
        },
      });
    },
    // 重置
    reset() {
      this.form.searchContent = "";
      this.form.equipmentType = "";
      this.form.mrMac = "";
      this.form.mrMeCard = "";
      this.getList();
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteReaderEquipment(row.id).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
          this.getList();
        });
      });
    },
  },
  mounted() {
    this.getList();
    this.getTypeList();
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container::v-deep {
  display: flex;
  width: 100%;
  padding-top: 2vh;
  box-sizing: border-box;
  position: relative;
  .left-part {
    position: absolute;
    left: 0;
    .equipment-title {
      background: url(@/assets/images/titleBg.png);
      background-size: 100% 100%;
      width: 11.1vw;
      height: 5.5vh;
      color: #fff;
      font-size: calc(100vw * 20 / 1920);
      text-align: center;
      line-height: 5.5vh;
      margin-bottom: 1.8vh;
    }
  }
  .right-part {
    width: 83vw;
    position: absolute;
    left: 0.8vw;
    right: 0;
    margin: 0 auto;
    .right-top {
      width: 60vw;
      margin: 0 auto;
      // margin-bottom: 4.6vh;
      .add-btn {
        background: url(@/assets/images/updown.png);
        background-size: 100% 100%;
        width: 7.2vw;
        height: 4.6vh;
        font-size: calc(100vw * 18 / 1920);
        margin-left: 2vw;
        color: #02b5ff;
        text-align: center;
        line-height: 4.6vh;
        cursor: pointer;
      }
    }
  }
}
.el-form-item::v-deep {
  display: flex;
  height: 4.6vh;
  align-items: center;
  .el-form-item__label {
    width: 7vw;
    text-align: left;
    color: #fff;
    font-size: calc(100vw * 16 / 1920);
  }
  .el-input__inner {
    height: 4.6vh;
    background: #0f2455;
    border: 1px solid #286ae8;
    color: #fff;
    font-size: calc(100vw * 16 / 1920);
    border-radius: 6px;
    &::placeholder {
      color: #fff;
    }
  }
}
::v-deep .el-table {
  width: 99.9%;
  margin-bottom: 2.5vh;
  font-size: calc(100vw * 16 / 1920);
}
::v-deep .el-table__body {
  font-size: calc(100vw * 14 / 1920);
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  display: none;
}
::v-deep .el-button {
  background: none;
  color: #02b5ff;
  border: none;
  text-decoration: underline;
}
::v-deep .el-pagination {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1vh;
}
::v-deep .el-pagination .el-select .el-input .el-input__inner,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev,
::v-deep .el-pager li,
::v-deep .el-pager li.btn-quicknext,
::v-deep .el-pager li.btn-quickprev,
::v-deep .el-pagination__total {
  background: #0f2455;
  border-radius: 6px;
  border: 1px solid #286ae8;
  color: #fff;
  text-align: center;
}
::v-deep .el-pager li,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev {
  margin-right: 0.5vw;
}
::v-deep .el-pagination__total {
  margin-right: 0;
  padding: 0 0.8vw;
  box-sizing: border-box;
}
::v-deep .el-select .el-input.is-disabled .el-input__inner {
  background: #0f2455;
  border: 1px solid #286ae8;
  &::placeholder {
    color: #fff;
  }
}
::v-deep .el-pager li.active {
  color: #409EFF;
}
</style>
